import links from '@/constants/links';

export default {
    list: [{
            id: 1,
            title: 'components.communities.list.page.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/fb-logo.png',
            icon: 'fab fa-facebook-f',
            subtitle: 'components.communities.list.page.subtitle',
            brief: 'components.communities.list.page.brief',
            link: links.communities.fbPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 2,
            title: 'components.communities.list.discord.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/discord-logo.jpg',
            icon: 'fab fa-discord',
            subtitle: 'components.communities.list.discord.subtitle',
            brief: 'components.communities.list.discord.brief',
            link: links.communities.discord,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 3,
            title: 'components.communities.list.yt.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/yt-logo.jpg',
            icon: 'fab fa-youtube',
            subtitle: 'components.communities.list.yt.subtitle',
            brief: 'components.communities.list.yt.brief',
            link: links.communities.ytChannel,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 4,
            title: 'components.communities.list.twitch.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/twitch-icon.jpg',
            icon: 'fab fa-twitch',
            subtitle: 'components.communities.list.twitch.subtitle',
            brief: 'components.communities.list.twitch.brief',
            link: links.communities.twitch,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 5,
            title: 'components.communities.list.gb.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/giantbomb.jpg',
            icon: 'fad fa-gamepad',
            subtitle: 'components.communities.list.gb.subtitle',
            brief: 'components.communities.list.gb.brief',
            link: links.communities.giantBomb,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 6,
            title: 'components.communities.list.fw.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/fandomwiki.png',
            icon: 'fab fa-wikipedia-w',
            subtitle: 'components.communities.list.fw.subtitle',
            brief: 'components.communities.list.fw.brief',
            link: links.communities.fandomWiki,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 7,
            title: 'components.communities.list.insta.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/instagram-icon.png',
            icon: 'fab fa-instagram',
            subtitle: 'components.communities.list.insta.subtitle',
            brief: 'components.communities.list.insta.brief',
            link: links.communities.instaPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 8,
            title: 'components.communities.list.twitter.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/twitter-icon.png',
            icon: 'fab fa-twitter',
            subtitle: 'components.communities.list.twitter.subtitle',
            brief: 'components.communities.list.twitter.brief',
            link: links.communities.twitterPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 9,
            title: 'components.communities.list.reddit.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/reddit-icon.png',
            icon: 'fab fa-reddit-alien',
            subtitle: 'components.communities.list.reddit.subtitle',
            brief: 'components.communities.list.reddit.brief',
            link: links.communities.redditPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 10,
            title: 'components.communities.list.fbGroup.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/fb-logo.png',
            icon: 'fab fa-facebook-messenger',
            subtitle: 'components.communities.list.fbGroup.subtitle',
            brief: 'components.communities.list.fbGroup.brief',
            link: links.communities.fbGroup,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        },
        {
            id: 11,
            title: 'components.communities.list.linkedIn.title',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/linkedin-icon.png',
            icon: 'fab fa-linkedin',
            subtitle: 'components.communities.list.linkedIn.subtitle',
            brief: 'components.communities.list.linkedIn.brief',
            link: links.communities.linkedInPage,
            flexExtraSmall: 12,
            flexSmall: 12,
            flexMedium: 12,
            flexLarge: 4,
            isActive: true,
        }
    ]
}
